<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Panels" pageTitle="Panels" />
            <PanelsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import PanelsContent from '../Panels/PanelsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'PanelsPage',
    components: {
        MainHeader,
        PageTitle,
        PanelsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>